import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_ENDURO_45 } from "@/lib/programs/enduroAventura45";

export default function EnduroAventura45Page() {
  return <ProgramTemplate program={PROGRAM_ENDURO_45} variant="enduro" showJourneyChronology />;
}
